import React from 'react';
import './App.css';
import logoWhite from './assets/cypherBusinessLogoWhite.svg';
import YC from './assets/YCombinatorLogo.svg';
import cashIcon from './assets/cashIcon.svg';
import eyeIcon from './assets/eyeIcon.svg';
import productImg from './assets/product1.svg';
import bg1 from './assets/bg1.svg';
import corporateCardsIcon from './assets/corporateCardsIcon.svg';
import wireTransfer from './assets/wireTransfersIcon.svg';
import spendControl from './assets/spendControlIcon.svg';
import accounting from './assets/accountingIntegrationsIcon.svg';
import reimbursement from './assets/reimbursementsIcon.svg';
import offramp from './assets/offRampIcon.svg';
import shardeum from './assets/shardeum.svg';
import gmx from './assets/gmx.svg';
import takado from './assets/takado.svg';
import bandit from './assets/bandit.svg';
import deltaPrime from './assets/deltaPrime.svg';
import benqi from './assets/benqi.svg';
import mintair from './assets/mintair.svg';
import weaveDb from './assets/weaveDb.svg';
import tegro from './assets/tegro.svg';
import zeroxPpl from './assets/0xppl.svg';
import Collapsible from 'react-collapsible';
import ReactGA from 'react-ga4';
import NavBar from './components/navbar';
import { RedirectURLs } from './constants/redirectURLS';

ReactGA.initialize('G-ZV64H3Y339');

const images = [
  shardeum,
  gmx,
  takado,
  bandit,
  deltaPrime,
  benqi,
  mintair,
  weaveDb,
  tegro,
  zeroxPpl,
];

const ImageCarousel = () => {
  const allImages = [...images, ...images, ...images, ...images];

  return (
    <div className='scrolling-container'>
      <div className='scrolling-animation flex space-x-12'>
        {allImages.map((src, index) => (
          <img key={index} src={src} alt={'brand logo'} className='h-12 ' />
        ))}
      </div>
    </div>
  );
};

export default function CypherBusiness() {
  return (
    <div className='overflow-y-scroll text-[#434343] bg-white pt-6 h-screen overflow-x-hidden'>
      <div className=''>
        <NavBar />
      </div>
      {/* Header */}
      <div className='flex justify-between md:px-40 px-6 mt-20'>
        <img src={logoWhite} alt='Logo' className='md:w-[180px] w-[130px]' />
        <a
          className='border border-[#F7C645] bg-[#F7C645] rounded-md px-8 md:px-12 py-3 sm:my-auto text-center text-xs md:text-base font-bold cursor-pointer'
          href='https://business.cypherhq.io'
          target='_blank'
          rel='noopener noreferrer'
        >
          {'Login'}
        </a>
      </div>

      <div className='relative'>
        {/* yellow circle */}
        <div className='absolute -left-[20%] w-[16rem] h-[16rem] blur-[6rem] opacity-60 md:-left-[13%] md:w-[32rem] md:h-[32rem] md:blur-[6rem] md:opacity-80 bg-[#FFEEC0] rounded-full' />

        {/* title */}
        <div className='text-center mx-auto mt-16'>
          <p className='font-extrabold text-[24px] md:text-[42px] w-[70%] md:max-w-[40%] mx-auto'>
            {'Financial operating system for web3 teams'}
          </p>
          {/* <p className='font-extrabold text-[42px]'>{' '}</p> */}
        </div>

        {/* sub-title */}
        <div className='text-center mx-auto mt-6 w-[67%] md:max-w-[50%]'>
          <p className='font-semibold text-[13px] md:text-[18px] z-10'>
            {
              'Manage Card Spend & Pay Vendors, Contractors, and Employees Directly from Your Gnosis Safe or Ledger. Built for Web3 Teams & DAOs.'
            }
          </p>
        </div>

        {/* YC */}
        <div className='mt-6 w-full flex items-center justify-center space-x-4'>
          <p className='font-bold text-[14px] md:text-[17px] '>{'Backed by'}</p>
          <img src={YC} className='w-[88px] md:w-[120px]' alt='YC_Logo' />
        </div>
      </div>

      <div className='relative mt-20 mx-6 md:mt-32 md:mx-40'>
        <div className='bg-white flex items-center space-x-4 p-2 md:p-4 rounded-md w-36 md:w-80 absolute -bottom-12 md:-bottom-16 border z-10'>
          <img src={cashIcon} className='w-[20px] md:w-[100px]' alt='cash' />
          <p className='text-[6px] md:text-base font-bold'>
            {'Your AWS bill just got paid with 3567.50 USDC'}
          </p>
        </div>
        <div className='border border-[#F7C645] bg-[#F7C645] rounded-lg px-6 py-2 md:px-12 md:py-4 text-center text-xs md:text-base font-bold cursor-pointer w-32 md:w-60 mx-auto'>
          <a
            href='https://calendly.com/growth-cypherhq'
            target='_blank'
            rel='noopener noreferrer'
          >
            {'Book a demo'}
          </a>
        </div>
        <div className='text-center mt-2'>
          <a
            className='text-[14px] font-medium underline'
            href={`${RedirectURLs.business}/?isDemo=true`}
            target='_blank'
            rel='noopener noreferrer'
          >
            {'Try it out'}
          </a>
        </div>
        <div className='bg-white flex items-center space-x-4 p-2 md:p-4 rounded-md w-36 md:w-80 absolute -top-12 md:-top-20 right-0 border z-10'>
          <img src={eyeIcon} className='w-[20px] md:w-[100px]' alt='eye' />
          <p className='text-[6px] md:text-base font-bold'>
            {'Your wire transfer to UX Designer just got processed'}
          </p>
        </div>

        {/* green circle */}
        <div className=' absolute w-[16rem] h-[16rem] -right-[29%] -top-20 opacity-45 md:-right-[23%] md:-top-6 md:w-[32rem] md:h-[32rem] bg-[#048A81] rounded-full blur-[6rem] md:opacity-25' />
      </div>

      <div className='mx-auto z-50'>
        <img
          src={productImg}
          alt='productImg'
          className='mx-auto w-full md:h-[56rem] h-[28rem]'
        />
      </div>

      <div
        style={{ backgroundImage: `url(${bg1})` }}
        className='w-full bg-cover bg-top bg-no-repeat md:h-24 h-12'
      ></div>

      <div
        // style={{ backgroundImage: `url(${bg1})` }}
        className='bg-[#EFF3F6] w-full bg-cover bg-top bg-no-repeat'
      >
        <div className='px-12 md:px-48 md:pt-[8rem] pb-8 md:pb-16 grid sm:grid-cols-1 sm:grid-rows-1 md:grid-cols-3 md:grid-rows-2 md:gap-12 gap-6'>
          <div className='bg-white rounded-lg p-8'>
            <div className='flex justify-start items-center space-x-4'>
              <img src={corporateCardsIcon} alt='corporateCardsIcon' />
              <p className='font-bold text-base'>{'Corporate Cards'}</p>
            </div>
            <p className='font-semibold text-base mt-6'>
              {
                'You can issue multi cards for your team members and departments to pay your business expenses and simplify expense management.'
              }
            </p>
          </div>

          <div className='bg-white rounded-lg p-8'>
            <div className='flex justify-start items-center space-x-4'>
              <img src={wireTransfer} alt='wireTransfer' />
              <p className='font-bold text-base'>{'Global Wire Transfers'}</p>
            </div>
            <p className='font-semibold text-base mt-6'>
              {
                'You can originate in USDC and pay your team members or vendors in fiat and you can initiate SWIFT wires, ACH transfers (US) and NEFT payments (INR).'
              }
            </p>
          </div>

          <div className='bg-white rounded-lg p-8'>
            <div className='flex justify-start items-center space-x-4'>
              <img src={spendControl} alt='spendControl' />
              <p className='font-bold text-base'>{'Spend Controls'}</p>
            </div>
            <p className='font-semibold text-base mt-6'>
              {
                'You can set a spend limit for each card/user and restrict spend to specific merchant categories or merchants for spend.'
              }
            </p>
          </div>

          <div className='bg-white rounded-lg p-8'>
            <div className='flex justify-start items-center space-x-4'>
              <img src={accounting} alt='accounting' />
              <p className='font-bold text-base'>{'Accounting Integrations'}</p>
            </div>
            <p className='font-semibold text-base mt-6'>
              {
                'We can sync the blockchain and card spend transactions into your accounting systems like QuickBooks, Xero in the required format.'
              }
            </p>
          </div>

          <div className='bg-white rounded-lg p-8'>
            <div className='flex justify-start items-center space-x-4'>
              <img src={reimbursement} alt='reimbursement' />
              <p className='font-bold text-base'>{'Reimbursements'}</p>
            </div>
            <p className='font-semibold text-base mt-6'>
              {
                'You can reimburse your team members and vendors for necessary business expenses either in USDC or fiat.'
              }
            </p>
          </div>

          <div className='bg-white rounded-lg p-8'>
            <div className='flex justify-start items-center space-x-4'>
              <img src={offramp} alt='offramp' />
              <p className='font-bold text-base'>{'Tablecoin Off-Ramp'}</p>
            </div>
            <p className='font-semibold text-base mt-6'>
              {
                'You can instantly convert your USDC to USD before funding the corporate card or sending out wire transfers.'
              }
            </p>
          </div>
        </div>
      </div>

      <div className='py-16 border-b'>
        <ImageCarousel />
      </div>

      {/* frequently asked question  FAQ */}
      <div className='grid sm:grid-cols-1 md:grid-cols-[6fr_8fr] mx-auto md:mx-40 my-12 md:my-20'>
        <div>
          <p className='font-extrabold md:text-[60px] text-[24px] text-center md:text-left w-full'>
            {'Frequently Asked'}
          </p>
          <p className='font-extrabold md:text-[60px] text-[24px] text-[#F7C645] text-center md:text-left w-full'>
            {'Questions'}
          </p>
        </div>
        <div>
          <div className='space-y-2 md:space-y-4 w-full'>
            <Collapsible
              tabIndex={0}
              className={'p-6'}
              openedClassName={'bg-[#F3FCFC] p-6 rounded-lg'}
              trigger={
                <div className='flex justify-between items-center'>
                  <p className='font-bold text-[14px] md:text-[22px] font-nunito'>
                    {'What are the benefits of using Cypher Business?'}
                  </p>
                  <div className='bg-[#FEF6E2] px-3 py-1 rounded-full text-xl'>
                    {'+'}
                  </div>
                </div>
              }
              triggerWhenOpen={
                <div className='flex justify-between items-center'>
                  <p className='font-bold text-[14px] md:text-[22px] font-nunito'>
                    {'What are the benefits of using Cypher Business?'}
                  </p>
                  <div className='text-xl px-3 py-1'>{'-'}</div>
                </div>
              }
            >
              {
                <div className='mt-3 text-[14px] md:text-base'>
                  {
                    'Cypher business let’s you Simplify business crypto spending with easy-to-use cards, issue multiple cards to your team, set individual spending limits, Seamlessly pay vendors, contractors, and employees worldwide and track every transaction under one undefined dashboard'
                  }
                </div>
              }
            </Collapsible>
            <Collapsible
              className={'p-6'}
              openedClassName={'bg-[#F3FCFC] p-6 rounded-lg'}
              trigger={
                <div className='flex justify-between items-center'>
                  <p className='font-bold text-[14px] md:text-[22px] font-nunito'>
                    {'What documents are required to set up an account?'}
                  </p>
                  <div className='bg-[#FEF6E2] px-3 py-1 rounded-full text-xl'>
                    {'+'}
                  </div>
                </div>
              }
              triggerWhenOpen={
                <div className='flex justify-between items-center'>
                  <p className='font-bold text-[14px] md:text-[22px] font-nunito'>
                    {'What documents are required to set up an account?'}
                  </p>
                  <div className='text-xl px-3 py-1'>{'-'}</div>
                </div>
              }
            >
              {
                <div>
                  <div className='mt-3 text-[14px] md:text-base'>
                    <div>
                      To complete KYB, you'll need to provide a few documents:
                    </div>
                    <ul class='list-disc'>
                      <li>
                        {
                          '~ A certificate listing your current directors, officers, and those who own more than 10% of the company (beneficial owners). This document should come from your registered agent,'
                        }
                      </li>
                      <li>
                        {
                          '~ Any licenses or registrations required for your industry.'
                        }
                      </li>
                      <li>
                        {
                          '~ Copies of IDs for everyone listed on the director/owner certificate.'
                        }
                      </li>
                    </ul>
                  </div>
                </div>
              }
            </Collapsible>
            <Collapsible
              tabIndex={0}
              className={'p-6'}
              openedClassName={'bg-[#F3FCFC] p-6 rounded-lg'}
              trigger={
                <div className='flex justify-between items-center'>
                  <p className='font-bold text-[14px] md:text-[22px] font-nunito'>
                    {'How long does it take to set up an account?'}
                  </p>
                  <div className='bg-[#FEF6E2] px-3 py-1 rounded-full text-xl'>
                    {'+'}
                  </div>
                </div>
              }
              triggerWhenOpen={
                <div className='flex justify-between items-center'>
                  <p className='font-bold text-[14px] md:text-[22px] font-nunito'>
                    {'How long does it take to set up an account?'}
                  </p>
                  <div className='text-xl px-3 py-1'>{'-'}</div>
                </div>
              }
            >
              {
                <div className='mt-3 text-[14px] md:text-base'>
                  {
                    'The account setup process typically involves two steps: bank approval and our internal setup. The bank usually takes 24 to 48 business hours to approve your KYB documents. Once approved, we can set up your account within 6 to 12 hours. In total, you can expect your account to be ready within 2 to 3 business days after submitting your KYB information.'
                  }
                </div>
              }
            </Collapsible>
            <Collapsible
              className={'p-6'}
              openedClassName={'bg-[#F3FCFC] p-6 rounded-lg'}
              trigger={
                <div className='flex justify-between items-center'>
                  <p className='font-bold text-[14px] md:text-[22px] font-nunito'>
                    {'Are there any charges for using Cypher Business?'}
                  </p>
                  <div className='bg-[#FEF6E2] px-3 py-1 rounded-full text-xl'>
                    {'+'}
                  </div>
                </div>
              }
              triggerWhenOpen={
                <div className='flex justify-between items-center'>
                  <p className='font-bold text-[14px] md:text-[22px] font-nunito'>
                    {'Are there any charges for using Cypher Business?'}
                  </p>
                  <div className='text-xl px-3 py-1'>{'-'}</div>
                </div>
              }
            >
              {
                <div className='mt-3 text-[14px] md:text-base'>
                  {
                    "There's no signup fee to get started with our service. We also offer a free tier based on your monthly transaction volume. You can issue as many virtual and physical cards as needed for your team. We do worldwide shipping and charge a one-time shipping fee of $30/card to cover the cost of card production, secure delivery, and ongoing service improvements. A $35 fee applies to wire transfers."
                  }
                </div>
              }
            </Collapsible>
            <Collapsible
              className={'p-6'}
              openedClassName={'bg-[#F3FCFC] p-6 rounded-lg'}
              trigger={
                <div className='flex justify-between items-center'>
                  <p className='font-bold text-[14px] md:text-[22px] font-nunito'>
                    {'Is there any spending or transaction limit?'}
                  </p>
                  <div className='bg-[#FEF6E2] px-3 py-1 rounded-full text-xl'>
                    {'+'}
                  </div>
                </div>
              }
              triggerWhenOpen={
                <div className='flex justify-between items-center'>
                  <p className='font-bold text-[14px] md:text-[22px] font-nunito'>
                    {'Is there any spending or transaction limit?'}
                  </p>
                  <div className='text-xl px-3 py-1'>{'-'}</div>
                </div>
              }
            >
              {
                <div className='mt-3 text-[14px] md:text-base'>
                  {
                    'There are no limits on how much you can load, spend, or send transactions. However, to ensure security, each card has a default monthly spending limit of $7,000. This limit can be easily changed by the account admin if necessary.'
                  }
                </div>
              }
            </Collapsible>
            <Collapsible
              className={'p-6'}
              openedClassName={'bg-[#F3FCFC] p-6 rounded-lg'}
              trigger={
                <div className='flex justify-between items-center'>
                  <p className='font-bold text-[14px] md:text-[22px] font-nunito'>
                    {'Which countries does Cypher support?'}
                  </p>
                  <div className='bg-[#FEF6E2] px-3 py-1 rounded-full text-xl'>
                    {'+'}
                  </div>
                </div>
              }
              triggerWhenOpen={
                <div className='flex justify-between items-center'>
                  <p className='font-bold text-[14px] md:text-[22px] font-nunito'>
                    {'Which countries does Cypher support?'}
                  </p>
                  <div className='text-xl px-3 py-1'>{'-'}</div>
                </div>
              }
            >
              {
                <div className='mt-3 text-[14px] md:text-base'>
                  {
                    'Cypher is designed to be a global platform, so you can access our services wherever you are in the world making it easier to manage your finances internationally. Please note that we do not support OFAC listed countries.'
                  }
                </div>
              }
            </Collapsible>
          </div>
        </div>
      </div>

      {/* footer */}
      {/* <div className='bg-black grid md:grid-rows-[5fr_1fr] grid-cols-1'>
        <div className='pt-8 mx:pt-20 pb-10 px-40 md:grid md:grid-cols-2 hidden md:visible'>
          <div className='grid md:grid-cols-2'>
            <div>
              <img
                src={logoBlack}
                alt='cypher logo'
              />
            </div>
            <div className='space-y-1 md:space-y-4 text-white'>
              <p className='font-bold text-[14px] md:text-[22px]'>
                {'Service'}
              </p>
              <p className='font-semibold text-[16px]'>{'Crypto'}</p>
              <p className='font-semibold text-[16px]'>{'Funding'}</p>
              <p className='font-semibold text-[16px]'>{'Financial'}</p>
              <p className='font-semibold text-[16px]'>{'Investment'}</p>
              <p className='font-semibold text-[16px]'>{'Transfer'}</p>
            </div>
          </div>
          <div className='grid md:grid-cols-2'>
            <div className='space-y-4 text-white'>
              <p className='font-bold text-[14px] md:text-[22px]'>
                {'Company'}
              </p>
              <p className='font-semibold text-[16px]'>
                {'Terms & Conditions'}
              </p>
              <p className='font-semibold text-[16px]'>{'Privacy & Policy'}</p>
            </div>
            <div className='space-y-4 text-white'>
              <p className='font-bold text-[14px] md:text-[22px]'>
                {'Get in touch'}
              </p>
              <div className='border border-[#F7C645] bg-[#F7C645] rounded-lg px-10 py-2 text-center text-base font-bold cursor-pointer text-black w-40'>
                {'Sign up'}
              </div>
            </div>
          </div>
        </div>

        <div className='pt-8 pb-4 px-12 visible md:hidden'>
          <div>
            <img
              src={logoBlack}
              alt='cypher logo'
            />
          </div>
          <div className='grid grid-cols-2 mt-4'>
            <div className='space-y-4 text-white'>
              <p className='font-bold text-[14px] md:text-[22px]'>
                {'Service'}
              </p>
              <p className='font-semibold text-[16px]'>{'Crypto'}</p>
              <p className='font-semibold text-[16px]'>{'Funding'}</p>
              <p className='font-semibold text-[16px]'>{'Financial'}</p>
              <p className='font-semibold text-[16px]'>{'Investment'}</p>
              <p className='font-semibold text-[16px]'>{'Transfer'}</p>
            </div>

            <div className='space-y-4 text-white'>
              <p className='font-bold text-[14px] md:text-[22px]'>
                {'Company'}
              </p>
              <p className='font-semibold text-[16px]'>
                {'Terms & Conditions'}
              </p>
              <p className='font-semibold text-[16px]'>{'Privacy & Policy'}</p>
            </div>
          </div>

          <div className='mt-6'>
            <div className='space-y-4 text-white'>
              <p className='font-bold text-[14px] md:text-[22px]'>
                {'Get in touch'}
              </p>
              <div className='border border-[#F7C645] bg-[#F7C645] rounded-lg px-10 py-2 text-center text-base font-bold cursor-pointer text-black w-40'>
                {'Sign up'}
              </div>
            </div>
          </div>
        </div>
        <div className='w-full mt-4 mx-auto h-[1px] bg-[#373333]'></div>
      </div> */}
      <div className='md:flex md:justify-between text-white md:items-center text-center bg-black px-32 py-8'>
        <p className='font-semibold text-base'>{'@2024 All Right Reserved'}</p>
        <p className='font-semibold text-base'>
          {"Buidl'ed with 💛 by the Cypher team"}
        </p>
        <a
          className='font-semibold text-base hover:text-[#F7C645]'
          rel='noopener noreferrer'
          href='https://www.cypherwallet.io/legal'
        >
          {'Privacy policy | Terms & conditions'}
        </a>
      </div>
    </div>
  );
}
